// import SubMenuItem from "@/components/appbar/SubMenuItem"

export default {
  name: "sub-menu",
  components: {
    SubMenuItem: () => import("./index.vue")
  },

  props: ["menuItem"],
  data() {
    return {};
  },

  methods: {
    menuClick() {
      if (this.menuItem.external) {
        window.open(this.menuItem.link);
      } else {
        this.$router.push(this.menuItem.link);
      }
      this.$emit("closeMenus");
    }
  }
};
